<!--
 * @Author: pengyong
 * @Date: 2020-12-05 21:09:20
 * @LastEditors: awu
 * @LastEditTime: 2020-12-06 21:41:24
 * @Description: 直播组件
 * @FilePath: /exhibit/src/components/LiveVideo/index.vue
-->
<template>
    <div class="live-video">
        <video
            id="hls-video"
            class="video-js vjs-default-skin"
            playsinline
            webkit-playsinline
            autoplay
            controls
            preload="auto"
            x-webkit-airplay="true"
            x5-video-player-fullscreen="true"
            x5-video-player-typ="h5"
        >
            <!-- 直播的视频源 -->
            <source :src="videoSrc" type="application/x-mpegURL" />
            <!--<source src="https://stream-hangzhou-gd-113-215-238-193.edgesrv.com:443/live" type="application/x-mpegURL" />-->
        </video>
    </div>
</template>

<script>
export default {
    props: {
        videoSrc: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            muted: true
        };
    },
    watch: {
        videoSrc: {
            handler(val) {
                if (val) {
                    console.log(val)
                    // // https://live-cn.yunzhizhan.cn/teet/scene-1.m3u8?auth_key=1609765807-0-0-fef4b21a9182ffc2477baf13694d8253
                    // XMLHttpRequest cannot load http://xxx/video.m3u8. No 'Access-Control-Allow-Origin' header is present on the requested resource. Origin 'http://192.168.198.98:8000' is therefore not allowed access.
                    // 由于 videojs-contrib-hls 需要通过 XHR 来获取解析 m3u8 文件, 因此会遭遇跨域问题, 请设置浏览器运行跨域
                    setTimeout(() => {
                        var player = videojs("hls-video");
                        player.play();
                    }, 20);
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss">
.live-video {
    width: 100%;
    height: 100%;
    position: relative;
    * {
        max-width: 100% !important;
        max-height: 100% !important;
    }
    .video-js {
        width: 100%;
        height: 100%;
        margin: 0 !important;
        .vjs-big-play-button {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/LiveVideo/index.vue